// store/vendor.search.slice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  filters: {
    rating: null,
    vendorType: [],
    serviceType: []
  },
  vendors: [],
  loading: false,
  scrollY: 0,
};

const vendorSearchSlice = createSlice({
  name: 'vendor',
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = action.payload;
    },
    setVendors: (state, action) => {
      state.vendors = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setScrollY: (state, action) => {
      console.log(action.payload)
      state.scrollY = action.payload;
    },
    resetVendors: (state) => {
      state.vendors = [];
    },
  },
});

export const {
  setFilters,
  setVendors,
  setLoading,
  setScrollY,
  resetVendors,
} = vendorSearchSlice.actions;

export default vendorSearchSlice.reducer;
